export const Orientation = Object.freeze({
  Vertical: Symbol("Vertical"),
  Horizontal: Symbol("Horizontal")
});

export const MetaType = Object.freeze({
  TEXT: 0,
  NUMBER: 1,
  CATEGORY: 2,
  DATE: 3
});

// Order for sorting DDT data in the DDT table.
export const MachineStatusOrder = Object.freeze({
  Online: 1,
  Derated: 2,
  Offline: 3
});

// IDs for creating machine statuses from name
export const MachineStatusIdLookup = Object.freeze({
  Offline: 0,
  Online: 1,
  Derated: 2
});

export const SeverityType = Object.freeze({
  UNASSIGNED: 0,
  SYSTEM: 1,
  GOOD: 2,
  WARNING: 3,
  PROGRESSED: 4,
  CRITICAL: 5
});

export const SeverityColour = Object.freeze({
  GRAY: "Gray",
  GREEN: "Green",
  BLUE: "Blue",
  YELLOWGREEN: "YellowGreen",
  YELLOW: "Yellow",
  RED: "Red"
});

export const ChartType = Object.freeze({
  TIME_SERIES: "time_series",
  SCATTER: "scatter"
});
